/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
    cellContent,
    row,
    rowIndex,
    { openEditReconcilePage, deleteReconcile, manualReconcile, openChooseReconcilePage, allowEdit, allowDelete, blockOrg }
) => (
    <>
        {/* {console.log(row)} */}
        <div className="row">
            <div className="col-12">
                {allowEdit && <OverlayTrigger
                    overlay={<Tooltip id="detail-trx-tooltip">Edit </Tooltip>}
                >
                    <a
                        className="btn btn-icon btn-light btn-hover-info btn-sm mb-1 mr-1"
                        onClick={() => openEditReconcilePage(row.uuid)}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-warning">
                            <SVG
                                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}

                            />
                        </span>
                    </a>
                </OverlayTrigger>}

                {blockOrg && allowDelete && row.status !== "SETTLE" && <OverlayTrigger
                    overlay={<Tooltip id="products-delete-tooltip">Hapus Settlement</Tooltip>}
                >
                    <a
                        className="btn btn-icon btn-light btn-hover-danger btn-sm"
                        onClick={() => {
                            deleteReconcile(row.uuid)
                        }}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-danger">
                            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
                        </span>
                    </a>
                </OverlayTrigger>}
            </div>

        </div>

    </>
);
